import React from "react";
import styles from "./YellowBox.module.css";
const YellowBox = (props) => {
    return (React.createElement("div", { className: `${styles.wrapper} ${props.isHeaderUpdateExp ? styles.newWrapper : ""} ${!props.hideShadow ? styles.wrapperShadow : ""} flights-sb` }, props.children));
};
export default YellowBox;
